import ApiJobMode from 'types/api/JobMode';
import { Option } from 'types/options';

import Model from 'models/Model';

export default class JobMode implements Model {
    id: string;
    name: string;
    slug: string;

    constructor(data: ApiJobMode) {
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
    }

    getOption = (): Option<JobMode> => {
        return {
            value: this,
            label: this.name,
        };
    };
}